import React from 'react'
import classNames from 'classnames'
import { Input, Text } from 'components'
import masks from 'utils/masks'
import { personTypes } from '../data'
import styles from '../ProposalWizard.module.scss'

const ProponentSection = ({ form, touched, errors, onChange, onBlur }) => {
  const documentMask = form.personType === 'pj' ? masks.cnpj : masks.cpf
  const documentLabel = form.personType === 'pj' ? 'CNPJ*' : 'CPF*'

  return (
    <section className={styles.section}>
      <p className={styles.sectionTitle}>
        <span className={styles.sectionNumber}>4</span>
        Dados do proponente
      </p>
      <Text fontSize="medium" color="secondaryColor">
        Tipo de pessoa*
      </Text>
      <div className={styles.personTypeCards}>
        {personTypes.map(type => (
          <button
            key={type.value}
            type="button"
            className={classNames(styles.personTypeCard, {
              [styles.selected]: form.personType === type.value,
            })}
            onClick={() => onChange('personType', type.value)}
          >
            {type.label}
          </button>
        ))}
      </div>
      <div className={styles.grid}>
        <Input
          id="name"
          label="Nome*"
          placeholder="Digite seu nome completo"
          value={form.name}
          onChange={e => onChange('name', e.target.value)}
          onBlur={onBlur('name')}
          hasError={touched.name && !errors.isNameValid}
          errorMessage="Informe o nome completo."
        />
        <Input
          id="document"
          label={documentLabel}
          mask={documentMask}
          alphaMask={
            form.personType === 'pj' ? masks.cnpjAlphanumeric : undefined
          }
          placeholder={documentMask}
          value={form.document}
          onChange={e => onChange('document', e.target.value)}
          onBlur={onBlur('document')}
          hasError={touched.document && !errors.isDocumentValid}
          errorMessage={`${documentLabel.replace('*', '')} inválido.`}
        />
        {form.personType !== 'pj' && (
          <Input
            id="birthDate"
            label="Data de nascimento*"
            mask={masks.date}
            placeholder={masks.date}
            value={form.birthDate}
            onChange={e => onChange('birthDate', e.target.value)}
            onBlur={onBlur('birthDate')}
            hasError={touched.birthDate && !errors.isBirthDateValid}
            errorMessage="Data de nascimento inválida."
          />
        )}
        <Input
          id="email"
          type="email"
          label="E-mail*"
          placeholder="exemplo@email.com"
          value={form.email}
          onChange={e => onChange('email', e.target.value)}
          onBlur={onBlur('email')}
          hasError={touched.email && !errors.isEmailValid}
          errorMessage="Informe um e-mail válido."
        />
        <Input
          id="whatsapp"
          label="WhatsApp*"
          mask={masks.phone}
          placeholder={masks.phone}
          value={form.whatsapp}
          onChange={e => onChange('whatsapp', e.target.value)}
          onBlur={onBlur('whatsapp')}
          hasError={touched.whatsapp && !errors.isWhatsappValid}
          errorMessage="Informe um WhatsApp válido."
        />
      </div>
      {form.personType === 'pj' && (
        <div className={styles.grid}>
          <Input
            id="representativeName"
            label="Nome do representante*"
            placeholder="Digite o nome completo do representante"
            value={form.representativeName}
            onChange={e => onChange('representativeName', e.target.value)}
            onBlur={onBlur('representativeName')}
            hasError={
              touched.representativeName && !errors.isRepresentativeNameValid
            }
            errorMessage="Informe o nome completo do representante."
          />
          <Input
            id="representativeDocument"
            label="CPF do representante*"
            mask={masks.cpf}
            placeholder={masks.cpf}
            value={form.representativeDocument}
            onChange={e => onChange('representativeDocument', e.target.value)}
            onBlur={onBlur('representativeDocument')}
            hasError={
              touched.representativeDocument &&
              !errors.isRepresentativeDocumentValid
            }
            errorMessage="CPF do representante inválido."
          />
          <Input
            id="representativeBirthDate"
            label="Data de nascimento do representante*"
            mask={masks.date}
            placeholder={masks.date}
            value={form.representativeBirthDate}
            onChange={e => onChange('representativeBirthDate', e.target.value)}
            onBlur={onBlur('representativeBirthDate')}
            hasError={
              touched.representativeBirthDate &&
              !errors.isRepresentativeBirthDateValid
            }
            errorMessage="Data de nascimento inválida."
          />
        </div>
      )}
      <Input
        id="observations"
        label="Observações (opcional)"
        className={styles.wizardTextarea}
        rows={3}
        value={form.observations}
        onChange={e => onChange('observations', e.target.value)}
      />
    </section>
  )
}

export default React.memo(ProponentSection)
